import { fromJS } from 'immutable'
import { createReducer } from 'redux-immutablejs'

import { TOOLKIT_CENTER_OF_EXCELLENCE_SUB_TOPIC } from '@lyrahealth-inc/shared-app-logic/src/features/centerOfExcellence/types'
import { ProviderProgramTaxonomy } from '@lyrahealth-inc/shared-app-logic/src/models/providers/Providers'
import {
  TriageRiskLevel,
  TriageSearchGenAiRequest,
} from '@lyrahealth-inc/shared-app-logic/src/models/searchForCare/SearchForCare'

import {
  CLEAR_TOOLKIT_SUB_TOPIC,
  CLEAR_TRIAGE,
  CREATING_SEARCH,
  DELETE_SCREENER_PROMPT,
  GET_ALL_TRIAGE_SEARCHES,
  GET_NEXT_TRIAGE_SCREEN,
  GET_WORD_CLOUD_WORDS,
  LOADING_NEXT_QUESTION,
  LOADING_TREATMENT_RECOMMENDATIONS,
  LOADING_WORD_CLOUD,
  MARK_HIGH_ALERT_CALLBACK_REQUESTED,
  POST_RISK_FACTORS,
  POST_TREATMENT_RECOMMENDATIONS,
  POST_TRIAGE_SEARCH,
  PUT_OR_PATCH_TRIAGE_SEARCH,
  PUT_RESET_TRIAGE_SEARCH_PROGRESS,
  RESET_PRESELECTED_TRIAGE_DATA,
  SET_AI_HIGH_RISK_MODAL_SHOWN_FOR_SEARCH_ID,
  SET_HAS_RESUMED_COMPLETED_SEARCH,
  SET_HIGH_ALERT,
  SET_HIGH_RISK_MODAL_LEVEL_SHOWN,
  SET_IS_SEARCH_TOOLKIT_AWARE,
  SET_PRESELECTED_TRIAGE_DATA,
  SET_PROGRAM_PREFERENCE,
  SET_PROGRESS_BAR_PERCENTAGE,
  SET_SCREENER_PROMPT,
  SET_SCREENERS,
  SET_SEARCHER_INFO,
  SET_SELECTED_SEARCH_ID,
  SET_TOOLKIT_SUB_TOPIC,
  SET_TREATMENT_RECS_SKIPPED,
  SET_TRIAGE_QUESTIONS,
  SHOULD_CREATE_NEW_SEARCH,
  UI_BACK_FROM_TREATMENT_RECS,
  UPDATING_SEARCH,
} from './triageActions'
import { DataAction } from '../../../data/reducers'
import { POST_USER_SEARCH_LOCATION_fulfilled } from '../../onboard/data/onboardDataActions'

const initialState = fromJS({
  screeners: [],
  searches: [],
  selectedSearchId: null,
  triageQuestions: [],
  searcherInfo: null,
  treatmentRecommendations: null,
  percentProgress: undefined,
  lastTriageScreener: null,
  updatingSearch: false,
  loadingNextQuestion: false,
  loadingTreatmentRecommendations: false,
  highAlert: {
    showModal: false,
    isActiveSI: false,
    isAiTriageHighRisk: false,
    aiRiskLevel: undefined,
  },
  highAlertCallbackRequested: false,
  highRiskModalLevelShown: undefined,
  aiHighRiskModalShownForSearchId: undefined,
  navigationState: {
    hasResumedCompletedSearch: false,
    uiBackFromTreatmentRecs: false,
  },
  wordCloud: null,
  loadingWordCloud: false,
  fetchedMetadataVersion: null,
  preselectedTriageData: undefined,
  getAllTriageSearchesState: 'pending',
  programPreference: undefined,
  isSearchToolkitAware: undefined,
  treatmentRecsSkipped: false,
  pendingGenAiRequests: {},
})

export default createReducer(initialState, {
  [SET_SCREENERS]: ($$state: $TSFixMe, action: $TSFixMe) => {
    $$state = $$state.set('screeners', fromJS(action.data.screeners))
    $$state = $$state.set('fetchedMetadataVersion', fromJS(action.data.version))
    return $$state
  },
  [GET_ALL_TRIAGE_SEARCHES]: ($$state: $TSFixMe, action: $TSFixMe) => {
    $$state = $$state.set('searches', fromJS(action.data))
    $$state = $$state.set('getAllTriageSearchesState', 'fulfilled')
    return $$state
  },
  [POST_RISK_FACTORS]: ($$state: $TSFixMe, action: $TSFixMe) => {
    $$state = $$state.set('riskFactors', fromJS(action.data))
    return $$state
  },
  [POST_TRIAGE_SEARCH]: ($$state: $TSFixMe, action: $TSFixMe) => {
    $$state = $$state.updateIn(['searches'], ($$searches: $TSFixMe) => $$searches.push(fromJS(action.data)))
    $$state = $$state.set('selectedSearchId', fromJS(action.data.id))
    return $$state
  },
  [PUT_OR_PATCH_TRIAGE_SEARCH]: ($$state: $TSFixMe, action: $TSFixMe) => {
    const searchIndex = $$state.get('searches').findIndex(($$search: $TSFixMe) => $$search.get('id') === action.data.id)
    if (searchIndex > -1) {
      $$state = $$state.setIn(['searches', searchIndex], fromJS(action.data))
    } else {
      $$state = $$state.updateIn(['searches'], ($$searches: $TSFixMe) => $$searches.push(fromJS(action.data)))
    }
    return $$state
  },
  [SET_SELECTED_SEARCH_ID]: ($$state: $TSFixMe, action: $TSFixMe) => {
    $$state = $$state.set('selectedSearchId', fromJS(action.data))
    return $$state
  },
  [SET_TRIAGE_QUESTIONS]: ($$state: $TSFixMe, action: $TSFixMe) => {
    $$state = $$state.set('triageQuestions', fromJS(action.data))
    return $$state
  },
  [GET_NEXT_TRIAGE_SCREEN]: ($$state: $TSFixMe, action: $TSFixMe) => {
    $$state = $$state.updateIn(['triageQuestions'], ($$questions: $TSFixMe) =>
      $$questions.push(fromJS(action.data.name)),
    )
    $$state = $$state.set(
      'lastTriageScreener',
      action.data.is_last_triage_screener ? fromJS(action.data.name) : undefined,
    )
    return $$state
  },
  [POST_TREATMENT_RECOMMENDATIONS]: ($$state: $TSFixMe, action: $TSFixMe) => {
    $$state = $$state.set('treatmentRecommendations', fromJS(action.data))
    return $$state
  },
  [PUT_RESET_TRIAGE_SEARCH_PROGRESS]: ($$state: $TSFixMe, action: $TSFixMe) => {
    const searchIndex = $$state.get('searches').findIndex(($$search: $TSFixMe) => $$search.get('id') === action.data.id)
    if (searchIndex > -1) {
      $$state = $$state.setIn(['searches', searchIndex], fromJS(action.data))
    } else {
      $$state = $$state.updateIn(['searches'], ($$searches: $TSFixMe) => $$searches.push(fromJS(action.data)))
    }
    return $$state
  },
  [GET_WORD_CLOUD_WORDS]: ($$state: $TSFixMe, action: $TSFixMe) => {
    const wordCloud = $$state.get('wordCloud')?.toJS() || {}
    $$state = $$state.set('wordCloud', fromJS({ ...wordCloud, [action.data.screenerName]: action.data.response }))
    return $$state
  },
  [UPDATING_SEARCH]: ($$state: $TSFixMe, action: $TSFixMe) => {
    $$state = $$state.set('updatingSearch', fromJS(action.data))
    return $$state
  },
  [CREATING_SEARCH]: ($$state: $TSFixMe, action: $TSFixMe) => {
    $$state = $$state.set('isCreatingSearch', fromJS(action.data))
    return $$state
  },
  [LOADING_NEXT_QUESTION]: ($$state: $TSFixMe, action: $TSFixMe) => {
    $$state = $$state.set('loadingNextQuestion', fromJS(action.data))
    return $$state
  },
  [SET_HIGH_RISK_MODAL_LEVEL_SHOWN]: ($$state: $TSFixMe, action: DataAction<TriageRiskLevel | undefined>) => {
    $$state = $$state.set('highRiskModalLevelShown', action.data)
    return $$state
  },
  [SET_AI_HIGH_RISK_MODAL_SHOWN_FOR_SEARCH_ID]: ($$state: $TSFixMe, action: DataAction<string | undefined>) => {
    $$state = $$state.set('aiHighRiskModalShownForSearchId', action.data)
    return $$state
  },
  [CLEAR_TRIAGE]: ($$state: $TSFixMe) => {
    $$state = $$state.set('selectedSearchId', null)
    $$state = $$state.set('triageQuestions', fromJS([]))
    $$state = $$state.set('lastTriageScreener', null)
    $$state = $$state.set('searcherInfo', null)
    $$state = $$state.set('treatmentRecommendations', null)
    $$state = $$state.set('updatingSearch', false)
    $$state = $$state.set('isCreatingSearch', false)
    $$state = $$state.set('loadingNextQuestion', false)
    $$state = $$state.set('shouldCreateNewSearch', false)
    $$state = $$state.setIn(['navigationState', 'hasResumedCompletedSearch'], false)
    $$state = $$state.setIn(['navigationState', 'uiBackFromTreatmentRecs'], false)
    $$state = $$state.set('wordCloud', null)
    $$state = $$state.set('loadingWordCloud', false)
    $$state = $$state.set('fetchedMetadataVersion', null)
    $$state = $$state.set('highRiskModalLevelShown', undefined)
    $$state = $$state.set('aiHighRiskModalShownForSearchId', undefined)
    $$state = $$state.set(
      'highAlert',
      fromJS({ showModal: false, isActiveSI: false, isAiTriageHighRisk: false, aiRiskLevel: undefined }),
    )
    $$state = $$state.set('preselectedTriageData', undefined)
    $$state = $$state.set('programPreference', undefined)
    $$state = $$state.set('isSearchToolkitAware', undefined)
    $$state = $$state.set('treatmentRecsSkipped', false)
    $$state = $$state.set('pendingGenAiRequests', fromJS({}))
    return $$state
  },
  [SET_IS_SEARCH_TOOLKIT_AWARE]: ($$state: $TSFixMe, action: DataAction<boolean>) => {
    $$state = $$state.set('isSearchToolkitAware', fromJS(action.data))
    return $$state
  },
  [LOADING_TREATMENT_RECOMMENDATIONS]: ($$state: $TSFixMe, action: $TSFixMe) => {
    $$state = $$state.set('loadingTreatmentRecommendations', fromJS(action.data))
    return $$state
  },
  [SET_SEARCHER_INFO]: ($$state: $TSFixMe, action: $TSFixMe) => {
    $$state = $$state.set('searcherInfo', fromJS(action.data))
    return $$state
  },
  [SET_HIGH_ALERT]: ($$state: $TSFixMe, action: $TSFixMe) => {
    $$state = $$state.set('highAlert', fromJS(action.data))
    return $$state
  },
  [MARK_HIGH_ALERT_CALLBACK_REQUESTED]: ($$state: $TSFixMe) => {
    $$state = $$state.set('highAlertCallbackRequested', true)
    return $$state
  },
  [SHOULD_CREATE_NEW_SEARCH]: ($$state: $TSFixMe, action: $TSFixMe) => {
    $$state = $$state.set('shouldCreateNewSearch', action.data)
    return $$state
  },
  [SET_HAS_RESUMED_COMPLETED_SEARCH]: ($$state: $TSFixMe, action: $TSFixMe) => {
    $$state = $$state.setIn(['navigationState', 'hasResumedCompletedSearch'], action.data)
    return $$state
  },
  [UI_BACK_FROM_TREATMENT_RECS]: ($$state: $TSFixMe, action: $TSFixMe) => {
    $$state = $$state.setIn(['navigationState', 'uiBackFromTreatmentRecs'], action.data)
    return $$state
  },
  [LOADING_WORD_CLOUD]: ($$state: $TSFixMe, action: $TSFixMe) => {
    $$state = $$state.set('loadingWordCloud', fromJS(action.data))
    return $$state
  },
  [SET_PRESELECTED_TRIAGE_DATA]: ($$state: $TSFixMe, action: $TSFixMe) => {
    $$state = $$state.set('preselectedTriageData', fromJS(action.data))
    return $$state
  },
  [RESET_PRESELECTED_TRIAGE_DATA]: ($$state: $TSFixMe) => {
    $$state = $$state.set('preselectedTriageData', undefined)
    return $$state
  },
  [SET_PROGRESS_BAR_PERCENTAGE]: ($$state: $TSFixMe, action: $TSFixMe) => {
    $$state = $$state.set('percentProgress', fromJS(action.data))
    return $$state
  },
  [SET_PROGRAM_PREFERENCE]: ($$state: $TSFixMe, action: DataAction<ProviderProgramTaxonomy>) => {
    $$state = $$state.set('programPreference', fromJS(action.data))
    return $$state
  },
  ['CLEAR_PROGRAM_PREFERENCE']: ($$state: $TSFixMe) => {
    $$state = $$state.set('programPreference', undefined)
    return $$state
  },

  [SET_TREATMENT_RECS_SKIPPED]: ($$state: $TSFixMe, action: DataAction<boolean>) => {
    $$state = $$state.set('treatmentRecsSkipped', fromJS(action.data))
    return $$state
  },
  [SET_TOOLKIT_SUB_TOPIC]: ($$state: $TSFixMe, action: DataAction<TOOLKIT_CENTER_OF_EXCELLENCE_SUB_TOPIC>) => {
    $$state = $$state.set('toolkitSubTopic', fromJS(action.data))
    return $$state
  },
  [SET_SCREENER_PROMPT]: (
    $$state: $TSFixMe,
    action: DataAction<
      TriageSearchGenAiRequest & {
        screenerPrompt: string
        highAlertRiskLevel?: string
      }
    >,
  ) => {
    const { searchId, submittedMetadataId, displayMetadataId, screenerPrompt, highAlertRiskLevel } = action.data
    const searchIndex = $$state.get('searches').findIndex(($$search: $TSFixMe) => $$search.get('id') === searchId)
    if (searchIndex === -1) return $$state

    // screenerPrompt === undefined means a loading state (GenAI request started but not completed)
    if (screenerPrompt === undefined) {
      return $$state.setIn(['pendingGenAiRequests', searchId, displayMetadataId], true)
    }

    $$state = $$state.deleteIn(['pendingGenAiRequests', searchId, displayMetadataId])
    return $$state.setIn(
      ['searches', searchIndex, 'metadata_context', submittedMetadataId, 'gen_ai_response'],
      fromJS({
        display_metadata_id: displayMetadataId,
        screenerPrompt,
        highAlertRiskLevel,
      }),
    )
  },
  [DELETE_SCREENER_PROMPT]: ($$state: $TSFixMe, action: DataAction<TriageSearchGenAiRequest>) => {
    const { searchId, displayMetadataId } = action.data
    const searchIndex = $$state.get('searches').findIndex(($$search: $TSFixMe) => $$search.get('id') === searchId)

    $$state = $$state.deleteIn(['pendingGenAiRequests', searchId, displayMetadataId])

    if (searchIndex === -1) return $$state

    const metadataContext = $$state.getIn(['searches', searchIndex, 'metadata_context'])
    if (!metadataContext) return $$state

    // Find and delete any existing GenAI response for this display screen
    const existingResponseKey = metadataContext.keySeq().find((key: string) => {
      const entry = metadataContext.get(key)
      return entry?.get('gen_ai_response')?.get('display_metadata_id') === displayMetadataId
    })

    if (existingResponseKey) {
      return $$state.deleteIn(['searches', searchIndex, 'metadata_context', existingResponseKey])
    }

    return $$state
  },
  [CLEAR_TOOLKIT_SUB_TOPIC]: ($$state: $TSFixMe) => {
    $$state = $$state.set('toolkitSubTopic', undefined)
    return $$state
  },
  [POST_USER_SEARCH_LOCATION_fulfilled]: ($$state: $TSFixMe, action: $TSFixMe) => {
    // Update the corresponding TriageSearch object with the user_search_location_id
    const searchId = action?.meta?.arg?.search_id
    const userSearchLocationId = action?.payload?.id

    if (searchId && userSearchLocationId) {
      const searchIndex = $$state.get('searches').findIndex(($$search: $TSFixMe) => $$search.get('id') === searchId)
      if (searchIndex > -1) {
        $$state = $$state.setIn(['searches', searchIndex, 'user_search_location_id'], userSearchLocationId)
      }
    }
    return $$state
  },
})
